import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface OpenStockParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface OpenStock {
    phCounterDet?:any;
    pharmcyCounterId?:any;
    id?: any;
    medicineID:string;
    batchNumber:string;
    expiryDate:any;
    pricePerStrips:number;
    sellPriceStrip:number;
    mrpPerStrip :number;
    gstTotalPer:number;
    referenceNo:string;
    referenceDate:Date;
    stockType:string;
    stockIn:number;
    stockOut:number;
    createdBy:string;
    createdDate:Date;
    branchType:string;
    pharmacyId:number;
    unitCostPrice:number;
    unitSellPrice:number;
    unitMrpPrice:number;
    tenantId:any;
    branchId:any;
   medicineList?:any;
    unitFlag?:any;
    parameters?: OpenStockParameter[];
    links?: any;
    warehouseId:number;
    pharmcyId?:any;
    isFreeQtyFlag?: boolean;
    unit?: number;
}


export abstract class OpenStockData {
    
    abstract list(url: string): Observable<OpenStock[]>;
    abstract create(url: string, data: OpenStock): Observable<OpenStock[]>;
    abstract update(url: string, data: OpenStock): Observable<OpenStock>;
    abstract delete(url: string): Observable<any>;
     abstract searchList(url: string,data:any): Observable<any>;
}
